import { AbstractControl, ValidationErrors } from "@angular/forms";

export class SpaceValidator {
  static cannotContainSpace(
    control: AbstractControl<string, string>,
  ): ValidationErrors | null {
    if (control && control.value && control.value.indexOf(" ") >= 0) {
      return { cannotContainSpace: true };
    }

    return null;
  }
}
